import {IOrder} from 'models/OrderManagement'
import {USER_CATEGORY} from 'constants/userCategory'

export const DISTRIBUTOR_ROLE =
 USER_CATEGORY.DISTRIBUTOR_DIRECTOR

export const isDistributorUser = (
 userCategoryKey?: string | null
) => userCategoryKey === DISTRIBUTOR_ROLE

const NEGOTIATION_STATUS_COLORS: Record<string, string> = {
 'Action Pending': 'text-[#E67E22]',
 'Pending Aggregator Confirmation': 'text-[#4E83E4]',
 'Awaiting Buyer Review': 'text-[#4E83E4]',
}

const NEGOTIATION_STATUS_CODE_COLORS: Record<
 string,
 string
> = {
 PENDING_SELLER_REVIEW: 'text-[#E67E22]',
 SELLER_REVIEW: 'text-[#E67E22]',
 PENDING_BUYER_REVIEW: 'text-[#4E83E4]',
 BUYER_REVIEW: 'text-[#4E83E4]',
}

export const isNegotiatedOrder = (record: {
 is_negotiated?: boolean | string
 negotiation_status?: string
 customer_quoted_total?: string | number
 seller_catalogue_total?: string | number
}) => {
 if (
  record.is_negotiated === true ||
  record.is_negotiated === 'true'
 ) {
  return true
 }
 if (record.negotiation_status) return true
 if (
  record.customer_quoted_total != null &&
  record.seller_catalogue_total != null &&
  Number(record.customer_quoted_total) !==
   Number(record.seller_catalogue_total)
 ) {
  return true
 }
 return false
}

export const getDisplayNegotiationStatus = (record: {
 derived_negotiation_status?: string
 order_status?: string
}) => {
 return (
  record.derived_negotiation_status ||
  record.order_status ||
  ''
 )
}

export const getNegotiationStatusColorClass = (record: {
 derived_negotiation_status?: string
 negotiation_status?: string
 is_negotiated?: boolean | string
}) => {
 const status = getDisplayNegotiationStatus(record)
 if (status && NEGOTIATION_STATUS_COLORS[status]) {
  return NEGOTIATION_STATUS_COLORS[status]
 }
 if (
  record.negotiation_status &&
  NEGOTIATION_STATUS_CODE_COLORS[record.negotiation_status]
 ) {
  return NEGOTIATION_STATUS_CODE_COLORS[
   record.negotiation_status
  ]
 }
 return 'text-[#E67E22]'
}

export const normalizeOrderRecord = (
 order: IOrder
): IOrder => ({
 ...order,
 is_negotiated: isNegotiatedOrder(order),
 derived_negotiation_status:
  getDisplayNegotiationStatus(order) ||
  order.derived_negotiation_status,
})
